/* unplugin-vue-components disabled */import script from "./avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./avatar.vue?vue&type=script&setup=true&lang=ts"

import "./avatar.vue?vue&type=style&index=0&id=37d705a0&lang=scss&scoped=true"

import exportComponent from "E:\\aodong\\work\\plus\\aodong-system-web-plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d705a0"]])

export default __exports__